import React from 'react';
import { RemoveScroll } from 'react-remove-scroll';
import { motion } from 'framer-motion';
import styles from '../../assets/styles/Modal/Modal.module.scss';
import { BsFillArrowLeftCircleFill } from 'react-icons/bs';
import { MimaButton } from '../Button';
import MimaText from '../MimaText';

const CenterModal = ({ closeModal, children, goBack, title }) => {
	return (
		<RemoveScroll>
			<motion.div
				initial={{
					opacity: 0,
				}}
				animate={{
					opacity: 1,
					transition: {
						duration: 0.2,
					},
				}}
				exit={{
					opacity: 0,
					transition: {
						duration: 0.2,
					},
				}}
				className={styles.center__background}
				onClick={closeModal}>
				<motion.div
					initial={{
						opacity: 0,
					}}
					animate={{
						opacity: 1,
						transition: {
							duration: 0.2,
						},
					}}
					exit={{
						opacity: 0,
						transition: {
							duration: 0.2,
						},
					}}
					className={styles.center__container}>
					<div
						className={
							goBack || title ? styles.center__top__2 : styles.center__top
						}
						onClick={e => {
							e.stopPropagation();
						}}>
						{goBack && (
							<BsFillArrowLeftCircleFill
								onClick={goBack}
								style={{ position: 'fixed' }}
							/>
						)}
						{title ? <MimaText variant="subtitleBold">{title}</MimaText> : ''}
						<div>
							<MimaButton title="X" variant="close" onClick={closeModal} />
						</div>
					</div>

					<div
						onClick={e => {
							e.stopPropagation();
						}}>
						{children}
					</div>
				</motion.div>
			</motion.div>
		</RemoveScroll>
	);
};

export default CenterModal;
